import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { XmTranslationModule } from '@xm-ngx/translation';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { TextBoxComponent } from './widgets/text-box/text-box.component';
import { NumberBoxComponent } from './widgets/number-box/number-box.component';
import { BasicWidgetComponent } from './widgets/basic-widget/basic-widget.component';
import { JsfComponentRegistryService } from '@xm-ngx/json-schema-form/components';

@NgModule({
    declarations: [
        TextBoxComponent,
        NumberBoxComponent,
        BasicWidgetComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        XmTranslationModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
    ],
    exports: [],
})
export class EeCoreWebappExtJsfModule {
    constructor(widgetService: JsfComponentRegistryService) {
        widgetService.registerWidget('ee-text-box', TextBoxComponent);
        widgetService.registerWidget('ee-number-box', NumberBoxComponent);
    }
}
